import type { CSSProperties } from 'react';

export const sessionStyles: Record<string, CSSProperties> = {
    overlay: {
        position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'radial-gradient(circle at 30% 20%, #292532 0%, #12131a 75%)', color: '#f4f0e6',
        fontFamily: 'Inter, system-ui, sans-serif', zIndex: 1000,
        padding: 'max(16px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-right)) max(16px, env(safe-area-inset-bottom)) max(16px, env(safe-area-inset-left))',
        boxSizing: 'border-box', overflowY: 'auto',
    },
    panel: {
        width: 'min(460px, 100%)', padding: 'clamp(20px, 5vw, 36px)', boxSizing: 'border-box',
        background: '#1d1e28', border: '1px solid #51475e', borderRadius: 6,
        boxShadow: '0 16px 48px #08091266', maxHeight: '100%', overflowY: 'auto',
    },
    title: { margin: '0 0 1.25rem', fontFamily: 'Georgia, serif', fontSize: 'clamp(28px, 5vw, 38px)', lineHeight: 1.15, fontWeight: 400, color: '#f4f0e6' },
    status: { marginBottom: '1rem', fontSize: '1rem', color: '#bbb5c9', lineHeight: 1.5 },
    progressOuter: { width: '100%', height: 6, background: '#35303f', borderRadius: 3, overflow: 'hidden' },
    progressInner: { height: '100%', background: '#e1edaa', transition: 'width 120ms ease-out' },
    error: { marginTop: '1rem', fontSize: '0.95rem', lineHeight: 1.5, color: '#efb0a7' },
};
